export interface EducationEntry {
  institution: string
  degree: string
  logo: string
  activities: string
  detail?: string
}

export const education: EducationEntry[] = [
  {
    institution: 'Oklahoma State University',
    degree: 'B.S., Journalism & Broadcasting',
    logo: 'https://cdn.magicpatterns.com/uploads/axBzCr1xixN7d99RMoFUVB/pasted-image.jpg',
    activities:
      "Member of Kappa Sigma Fraternity and worked on the school newspaper — the Daily O'Collegian. Recipient of the Distinguished Alumni Award (College of Arts & Sciences).",
    detail:
      'Served on the Advisory Board to the School of Journalism & Broadcasting and is a Life Member of the Oklahoma State Alumni Association. Has supported the Spears School of Business Veterans Entrepreneurship Program (VEP). One of only six Oklahoma State University graduates to attain the rank of Rear Admiral.',
  },
  {
    institution: 'University of Central Oklahoma',
    degree: 'M.Ed., Education',
    logo: 'https://cdn.magicpatterns.com/uploads/6PGoGL3gsimC27CaHZyCeb/pasted-image.jpg',
    activities:
      'Adjunct professor in the Department of Journalism, teaching courses in Mass Communications, Public Relations and Advertising.',
    detail:
      'Recipient of the Distinguished Alumni Award, served as "Leader in Residence," and a member of the Advisory Board for the School of Liberal Arts.',
  },
  {
    institution: 'University of Central Oklahoma',
    degree: 'Master of Business Administration',
    logo: 'https://cdn.magicpatterns.com/uploads/6PGoGL3gsimC27CaHZyCeb/pasted-image.jpg',
    activities: '21 hours completed toward the Master of Business Administration.',
  },
]

export const aboutParagraphs: string[] = [
  'Over 45 years of experience in government relations, strategic planning, business transformation, crisis communications, media training, public relations, marketing, and non-profit management.',
  'Experience includes broad and deep knowledge in providing strategic experience and counsel in executive agency interaction, constituent relations, personnel team building, motivation, management and organizational planning and formation. Strong leadership and problem-solving skills, having led targeted marketing campaigns and governmental initiatives in both the public and private sector.',
  'A trusted partner and strategic advisor to senior business and corporate executives and government leaders for community outreach, government and public affairs expertise, and an extensive network of corporate and government contacts. A highly visible leader with a broad network of relationships across government, state and community organizations. Retired Rear Admiral, United States Navy.',
]

export const specialties: string[] = [
  'Government Administration',
  'Crisis Communications',
  'Public & Media Relations',
  'Government Relations',
  'Strategic Marketing & Planning',
  'Keynote Speaker',
  'Legislative Liaison',
  'Executive Leadership Development',
  'Management Consulting',
  'Governmental Communications',
  'Business Transformation',
]

export const portraitImage =
  'https://cdn.magicpatterns.com/uploads/fBhGeSNwvfSW9ePocqrM1N/greg-slavonic.png'
